if (!customElements.get('c-ugc-social-proof')) {
  customElements.define(
    'c-ugc-social-proof',
    class UgcSocialProof extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('.c-ugc-social-proof__mosaic');
        this.videoCards = Array.from(this.querySelectorAll('.c-ugc-social-proof__card--video-card'));
        this.desktopQuery = window.matchMedia('(min-width: 768px)');
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
        this.initCarousel = this.initCarousel.bind(this);
        this.handleVideoClick = this.handleVideoClick.bind(this);
        this.stackReviews();
        this.track = this.querySelector('.c-ugc-social-proof__track');
        this.slides = Array.from(this.querySelectorAll('.c-ugc-social-proof__slide'));
        this.initializeVideos();
        this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
        this.handleBreakpointChange();
      }

      disconnectedCallback() {
        if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
        this.videoCards.forEach((card) => {
          const video = card.querySelector('video');
          if (video) video.pause();
          card.removeEventListener('click', this.handleVideoClick);
        });
        this.destroyCarousel();
      }

      initializeVideos() {
        this.videoCards.forEach((card) => {
          const video = card.querySelector('video');
          if (!video) return;

          video.muted = true;
          video.autoplay = false;
          video.playsInline = true;
          video.controls = false;
          video.pause();
          card.addEventListener('click', this.handleVideoClick);
          video.addEventListener('play', () => this.updateVideoState(card, true));
          video.addEventListener('pause', () => this.updateVideoState(card, false));
          video.addEventListener('ended', () => this.updateVideoState(card, false));
          this.updateVideoState(card, false);
        });
      }

      handleVideoClick(event) {
        if (this.slider && this.slider.slider && !this.slider.slider.allowClick) return;

        const card = event.currentTarget;
        const video = card.querySelector('video');
        if (!video) return;

        if (video.paused) {
          this.pauseOtherVideos(video);
          video.muted = false;
          video.play().catch(() => {
            video.muted = true;
            return video.play();
          });
          return;
        }

        video.pause();
      }

      updateVideoState(card, isPlaying) {
        const playControl = card.querySelector('.c-ugc-social-proof__play-control');
        card.classList.toggle('is-playing', isPlaying);
        if (playControl) playControl.setAttribute('aria-pressed', String(isPlaying));
      }

      pauseOtherVideos(activeVideo) {
        this.videoCards.forEach((card) => {
          const video = card.querySelector('video');
          if (video && video !== activeVideo) {
            video.pause();
            video.muted = true;
          }
        });
      }

      handleBreakpointChange() {
        if (this.desktopQuery.matches) {
          this.initCarousel();
        } else {
          this.destroyCarousel();
        }
      }

      initCarousel() {
        if (this.slider || !this.carousel || !this.track) return;

        if (!window.FoxTheme || !window.FoxTheme.Carousel) {
          if (this.desktopQuery.matches) window.requestAnimationFrame(this.initCarousel);
          return;
        }

        this.carousel.classList.add('swiper');
        this.track.classList.add('swiper-wrapper');
        this.slides.forEach((slide) => slide.classList.add('swiper-slide'));
        this.slider = new window.FoxTheme.Carousel(this.carousel, {
          slidesPerView: 'auto',
          spaceBetween: 24,
          breakpoints: {
            768: { spaceBetween: 24 },
            978: { spaceBetween: 24 },
            1200: { spaceBetween: 24 },
            1980: { spaceBetween: 24 },
          },
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
          loop: false,
          observer: true,
          observeParents: true,
        });
        this.slider.init();
      }

      destroyCarousel() {
        if (this.slider && this.slider.slider) this.slider.slider.destroy(true, true);
        this.slider = null;
        if (this.carousel) this.carousel.classList.remove('swiper');
        if (this.track) this.track.classList.remove('swiper-wrapper');
        if (this.slides) this.slides.forEach((slide) => slide.classList.remove('swiper-slide'));
      }

      stackReviews() {
        const slides = Array.from(this.querySelectorAll('.c-ugc-social-proof__slide'));
        let activeStack = null;

        slides.forEach((slide) => {
          const reviewCard = slide.querySelector('.c-ugc-social-proof__card--review-card');
          const isStacked = reviewCard && reviewCard.dataset.blockLayout === 'stack';

          if (!isStacked) {
            activeStack = null;
            return;
          }

          if (activeStack) {
            activeStack.append(reviewCard);
            slide.remove();
            return;
          }

          activeStack = slide;
        });
      }
    }
  );
}